import {
    MenuIcon as SourceMenuIcon
} from 'SourceComponent/MenuIcon/MenuIcon.component';
import { getUrlMedia } from 'Util/Store';

import './MenuIcon.override.style';

/** @namespace Elganso/Component/MenuIcon/Component */
export class MenuIconComponent extends SourceMenuIcon {
    render() {
        const urlMedia = `${getUrlMedia()}scandiweb/images/Menú.png`;

        return (
            <img src={ urlMedia } alt="Menú" />
        );
    }
}

export default MenuIconComponent;
